export const TaskTypeEnum = {
  A5Assessment: "A5_ASSESSMENT",
  ChangePassword: "CHANGE_PASSWORD",
  ACPSatisfactionSurvey: "COMPLETE_ACP_SATISFACTION_SURVEY",
  PhotoIDUpload: "ID_DOCUMENT_UPLOAD",
  SNSEAssessment: "COMPLETE_SNSE_ASSESSMENT",
  UpdatedChildConsent: "UPDATED_CHILD_CONSENT",
  UpdatedConsentRequired: "UPDATED_CONSENT_REQUIRED",
  UpdatedPolicies: "UPDATED_POLICIES",
} as const;
